import { useContext } from 'react';

import { ConfirmationContext } from './ConfirmationProvider';
import { IConfirmationProps } from './Confirmation';

export default function useConfirmation() {
	const { showConfirmation, hideConfirmation } = useContext(ConfirmationContext);

	return function confirm(props?: Partial<IConfirmationProps>) {
		return new Promise((resolve, reject) => {
			showConfirmation({
				resolve,
				reject,
				...props,
				open: true,
			});
		})
			.finally(() => {
				hideConfirmation();
			});
	};
}
